import { motion } from "framer-motion";
import { Reveal, SectionHeading } from "./Reveal";

const PORTRAIT =
  "https://images.unsplash.com/photo-1675629799514-da5137694e7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBwb3J0cmFpdCUyMGRhcmslMjBsaWdodCUyMGRyYW1hdGljfGVufDB8fHx8MTc5MTM1NzM0OXww&ixlib=rb-4.1.0&q=85";

const STATS = [
  { value: "150+", label: "Films & Stories" },
  { value: "12", label: "Countries Shot" },
  { value: "08", label: "International Awards" },
];

const GEAR = ["RED V-Raptor 8K", "Leica M11", "Cooke Anamorphic Lenses", "DJI Inspire 3"];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-28 sm:py-36 overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-5 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <motion.div
            aria-hidden
            className="absolute -top-16 left-1/2 -translate-x-1/2 w-[70%] h-[120%] animate-beam pointer-events-none"
            style={{
              clipPath: "polygon(44% 0, 56% 0, 92% 100%, 8% 100%)",
              background:
                "linear-gradient(180deg, rgba(247,244,238,0.16) 0%, rgba(229,192,123,0.04) 60%, transparent 100%)",
              filter: "blur(12px)",
            }}
          />
          <div className="relative border border-ivory/15 p-3">
            <span className="absolute -top-px -left-px w-6 h-6 border-t-2 border-l-2 border-amber" />
            <span className="absolute -bottom-px -right-px w-6 h-6 border-b-2 border-r-2 border-amber" />
            <div className="overflow-hidden">
              <img
                src={PORTRAIT}
                alt="Ansh Agarwal, photographer and filmmaker"
                data-testid="about-portrait"
                loading="lazy"
                className="w-full aspect-[4/5] object-cover grayscale hover:grayscale-0 transition-all duration-[1.4s]"
              />
            </div>
          </div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-mute mt-4 text-center">
            Director of Photography — Ansh Agarwal
          </p>
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        <SectionHeading eyebrow="The Eye Behind" title="Every frame carries silence & tension" testid="about-heading" />
        <Reveal delay={0.15}>
          <p className="font-serif text-lg sm:text-xl text-cream/90 leading-relaxed mt-8 font-light">
            I chase the half-second where light, dust and emotion collide — the moment a wedding
            tear becomes cinema, a stranger becomes a story, a landscape becomes a memory.
            Based between Mumbai and New Delhi, shooting worldwide.
          </p>
          <p className="font-mono text-xs sm:text-sm text-ash leading-loose mt-6">
            From palace weddings in Udaipur to fog highways in Iceland, ANSH AGARWAL FILMS builds
            images the way films are built — with patience, negative space, and an obsession for
            the last ray of usable light.
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="grid grid-cols-3 gap-px bg-line border border-line mt-12">
            {STATS.map((s) => (
              <div key={s.label} className="bg-ink p-5 sm:p-8 text-center">
                <p className="font-display text-3xl sm:text-5xl text-amber">{s.value}</p>
                <p className="font-mono text-[9px] sm:text-[10px] tracking-[0.25em] uppercase text-mute mt-3">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.35}>
          <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-amber mt-12 mb-4">In the bag</p>
          <ul className="flex flex-wrap gap-x-8 gap-y-2">
            {GEAR.map((g) => (
              <li key={g} className="font-mono text-[11px] tracking-[0.2em] uppercase text-cream flex items-center gap-2">
                <span className="w-1 h-1 rotate-45 bg-amber/70" />
                {g}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
